package com.eladfinish.bible.contest.common

import kotlin.js.js
import kotlin.reflect.KClass

// KClass.qualifiedName/simpleName throw at compile time on Kotlin/JS; `.js.name` is the
// JS-safe equivalent (the runtime constructor name — stable unless the build minifies names).
actual fun classNameOf(kClass: KClass<*>): String = kClass.js.name
